import React, { useState } from "react";
import DraggableItem from "./DraggableSubSectionItem";
import DraggableSubSectionItem from "./DraggableSubSectionItem";

export default function RearrangeSubSectionList({ rows, onDataReorder }) {
  const [dragId, setDragId] = useState();
  const [items, setItems] = useState(rows?.filter((value) => value.id > 0));

  const handleDrag = (ev) => {
    setDragId(ev.currentTarget.id);
  };

  const handleDrop = (ev) => {
    const dragItem = items.find((box) => box.id == dragId);
    const dropItem = items.find((box) => box.id == ev.currentTarget.id);

    const dragBoxOrder = dragItem.displayOrder;
    const dropBoxOrder = dropItem.displayOrder;

    const newItemState = items.map((item) => {
      if (item.id == dragId) {
        item.displayOrder = dropBoxOrder;
      }
      if (item.id == ev.currentTarget.id) {
        item.displayOrder = dragBoxOrder;
      }
      return item;
    });
    setItems(newItemState);
    onDataReorder(newItemState);
  };
  return (
    <>
      <div className="d-flex p-2 stepper-container">
        <div class=" stepper-containers MuiBox-root css-0">
          <div class="scroll-context MuiBox-root css-fg6w03">
            <nav>
              <ul class="MuiList-root MuiList-padding outlined-tabs css-15bdqf2-MuiList-root">
                {items
                  .sort((a, b) => a.displayOrder - b.displayOrder)
                  .map((box) => (
                    <DraggableSubSectionItem
                      detail={box}
                      key={box.id}
                      boxColor={box.color}
                      boxNumber={box.id}
                      handleDrag={handleDrag}
                      handleDrop={handleDrop}
                    />
                  ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
